import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OutboundCall } from '@/models/callLog';

export const fetchLiveOutboundCalls = async (): Promise<OutboundCall[]> => {
  const response = await queryExecute({
    query: graphql(`
      query LiveOutboundCalls {
        liveOutboundCalls {
          callerName
          callLogId
          callSid
          conferenceFriendlyName
          fromPhoneNumber
          toPhoneNumber
          operatorName
          purpose
          timeInMinutes
        }
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.liveOutboundCalls;
};
